(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('PolicyDetailController', PolicyDetailController);

    PolicyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Policy'];

    function PolicyDetailController($scope, $rootScope, $stateParams, previousState, entity, Policy) {
        var vm = this;

        vm.policy = entity;
        vm.previousState = previousState.name;
        
        $scope.aceLoaded = function(_editor){
			// Editor part
			var _session = _editor.getSession();
			var _renderer = _editor.renderer;

			// Options
			_session.setUndoManager(new ace.UndoManager());
			_editor.setHighlightActiveLine(true);
			_editor.setHighlightSelectedWord(true);
			_editor.setShowPrintMargin(false);

		};
		
		$scope.aceOptions = {
				useWrapMode : true,
				showGutter: true,
				mode: 'xml',
				firstLineNumber: 1,
				theme: 'tomorrow',
				onLoad: $scope.aceLoaded
		};

        var unsubscribe = $rootScope.$on('uniromaLandingApp:policyUpdate', function(event, result) {
            vm.policy = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
